import { config, gameState } from '@js/state';
import { enablePointerEvents } from '@utils/pointer-events-control';

let points;
let array;
const divide = false;

const fadeOut = false;

const joystickInput = false;

const sliderDrag = false;

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {
    this.load.multiatlas(
      'endConfetti',
      'assets/EndScreenAssets/confetti/confettiAnimNew.json',
      'assets/EndScreenAssets/confetti',
    );
    this.load.multiatlas(
      'rewardAnim',
      'assets/EndScreenAssets/rewardAnim/rewardAnim.json',
      'assets/EndScreenAssets/rewardAnim',
    );
  }

  create() {
    if (window.isLocalHost) enablePointerEvents();

    config.audio.bgaudio = this.sound.add('bgaudio');
    this.heliaudio = this.sound.add('heliaudio');

    this.add
      .sprite(config.width / 2, config.height / 2, 'startSceneBG')
      .setDisplaySize(1280, 720);

    this.add.sprite(config.width / 2, config.height / 2 - 40, 'gameName').setScale(0.67);

    this.playButton = this.add
      .sprite(config.width / 2, config.height / 2 + 100, 'playButton')
      .setScale(0.67)
      .setInteractive({ cursor: 'pointer' });

    this.playButton.on(
      'pointerover',
      function (pointer) {
        //this.playButton.setTint(0xc4c4c4);
        this.playButton.setTexture('playHover');
      },
      this,
    );
    this.playButton.on(
      'pointerout',
      function (pointer) {
        //this.playButton.setTint();
        this.playButton.setTexture('playButton');
      },
      this,
    );

    this.heli = this.physics.add
      .sprite(625, config.height - 360, 'heliAnim')
      .setScale(0.67)
      .setOrigin(0.5, 0.5);
    this.anims.create({
      key: 'heliPlay',
      frames: this.anims.generateFrameNames('heliAnim', {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: 'helihomescreen',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: -1,
    });
    this.heli.play('heliPlay');

    this.playButton.on(
      'pointerup',
      () => {
        this.playButton.setScale(0.67);

        this.playButton.disableInteractive();
      },
      this,
    );

    this.playButton.on(
      'pointerdown',
      function (pointer) {
        this.playButton.setScale(0.62);

        this.playButton.disableInteractive();

        config.audio.bgaudio.setLoop(true).setVolume(0.02).play();

        this.heliaudio.setLoop(true).setVolume(0.02).play();

        this.tweens.add({
          targets: this.heli,
          ease: 'Sine.easeInOut',
          duration: 1000,
          y: {
            getStart: () => config.height - 360,
            getEnd: () => -50,
          },
          yoyo: false,
          loop: 0,
        });

        this.tweens.add({
          targets: this.heli,
          ease: 'Sine.easeInOut',
          duration: 2200,
          delay: 1300,
          angle: {
            getStart: () => 0,
            getEnd: () => 30,
          },
          x: {
            getStart: () => 625,
            getEnd: () => 2000,
          },
        });

        this.tweens.add({
          targets: this.heliaudio,
          delay: 0,
          volume: 0,
          duration: 3000,
          onComplete: () => {},
        });
        this.time.delayedCall(
          3500,
          function () {
            this.scene.stop('StartScene');
            this.scene.start('TutorialScene');
            //this.scene.start("GameScene");
          },
          [],
          this,
        );
      },
      this,
    );
  }

  update() {}
}
